import Appsignal from '@appsignal/javascript'
import { APP_SIGNAL_API_KEY } from 'utils/env'

export const appsignal = new Appsignal({
  key: APP_SIGNAL_API_KEY,
})

export const paymentTypesValueDisplayed = {
  shift4_token: 'Shift4',
  shift4_credit: 'Shift4',
  freedompay_token: 'FreedomPay',
  freedompay_credit: 'FreedomPay',
  vn_bank: 'Virtual Currency',
  cash: 'Cash',
  direct_bill: 'Direct Bill',
  house_account: ' House Account',
  null: 'Custom Tender',
}

export const statusOptions = [
  { uuid: 'Bumped', name: 'Bumped' },
  { uuid: 'Cancelled', name: 'Cancelled' },
  { uuid: 'Completed', name: 'Completed' },
  { uuid: 'Delivered Without Alcohol', name: 'Delivered Without Alcohol' },
  { uuid: 'Not Collected', name: 'Not Collected' },
  { uuid: 'Processing', name: 'Processing' },
]

export const transactionHistoryStatus = {
  Settled: 'settled',
  Voided: 'voided',
  PaymentProcessing: 'payment-processing',
  Authorized: 'authorized',
  BLANK: 'blank',
  AuthFailed: 'auth-failed',
  Refunded: 'refunded',
  authorized: 'authorized',
  settled: 'settled',
  settlementFailed: 'settlement-failed',
  refunded: 'refunded',
  approved_offline: 'approved-offline',
  voided: 'voided',
  voidAttempted: 'void-attempted',
  debited: 'debited',
}

export const orderStates = {
  approved_offline: 'Approved Offline',
  assigned: 'Assigned',
  authorization_failed: 'Authorization Failed',
  bumped: 'Bumped',
  cancelled: 'Cancelled',
  completed: 'Completed',
  completion_pending: 'Completion Pending',
  delivered_without_alcohol: 'Delivered Without Alcohol',
  delivery_failed: 'Delivery Failed',
  incomplete: 'Incomplete',
  not_collected: 'Not Collected',
  partially_refunded: 'Partially Refunded',
  problem_reported: 'Problem Reported',
  processing: 'Processing',
  queued: 'Queued',
  refund_failed: 'Refund Failed',
  refunded: 'Refunded',
  settlement_failed: 'Settlement Failed',
  submission_failed: 'Submission Failed',
  submitted: 'Submitted',
  submitting: 'Submitting',
  tabbed: 'Tabbed',
  refund_pending: 'Refund Pending',
  closed_by_admin: 'Closed By Admin',
  tabbed_offline: 'Tabbed Offline',
}

// statuses as options available for "All Order Statuses" select
export const allOrderStatusesAvailableOptions = [
  'Processing',
  'Tabbed',
  'Completed',
  'Completion Pending',
  'Cancelled',
  'Refunded',
  'Partially Refunded',
  'Refund Failed',
  'Submitted',
  'Authorization Failed',
  'Approved Offline',
  'Tabbed Offline',
]

// statuses that allow to show complete order button
export const showOrderCompleteButtonStatuses = [
  'processing',
  'bumped',
  'assigned',
  'completion_pending',
  'settlement_failed',
]

export const refundReasons = [
  'Long wait for item',
  'Incorrectly entered order',
  'Insufficient inventory',
  'Guest changed their mind',
  'Item returned, quality related',
  'Duplicate',
]

export const SEARCH_BAR_ORDERS_OPTIONS = [
  {
    uuid: 'orderNumber',
    label: 'Order Number',
  },
  {
    uuid: 'userName',
    label: 'Customer',
  },
  {
    uuid: 'uuid',
    label: 'UUID',
  },
  {
    uuid: 'lastFour',
    label: 'Last 4',
  },
]

// when following states occur on order detailes, we have to disable refund button and display tooltip with reason
export const DISABLE_REFUND_STATES_REASONS = new Map([
  ['refunded', 'This order has already been refunded.'],
  ['submitted', 'This order is not in a refundable order state.'],
  ['submitting', 'This order is not in a refundable order state.'],
  ['authorization_failed', 'This order is not in a refundable order state.'],
  ['submission_failed', 'This order is not in a refundable order state.'],
  ['canceled', 'This order has been canceled and is not refunable.'],
  [
    'settlement_failed',
    'The original payment failed on this order and cannot be refunded.',
  ],
  [
    'completion_pending',
    'The order can be refunded after payment settlement at the business end time configured for this Revenue Center.',
  ],
  [
    'tabbed_offline',
    'Offline payments are not refundable. Try again after the payment(s) have been synced.',
  ],
])
